import Image from "next/image";

const Hero = () => (
  <>
    <div className="pt-56 md:pt-56 overflow-hidden  xl:pt-64 xl:px-8 bg-black">
      <div className="flex justify-center">
        <h1 className="absolute font-ubuntu text-3xl md:text-4xl xl:text-7xl xl:leading-tight font-bold text-white text-center xl:pt-16 top-28">
          Know Your Customer App <br />
          An App for Customer Reviews
        </h1>
      </div>
      <div className="relative text-center bg-[url(/assets/case-study/kyc/hero-mobile.svg)] md:bg-[url(/assets/case-study/kyc/hero-tab.svg)] xl:bg-[url(/assets/case-study/kyc/hero.webp)] bg-cover bg-center bg-no-repeat h-screen md:h-[170vh] xl:h-auto mt-8 md:mt-24 xl:mt-0">
        <div className="flex flex-col xl:flex-row">
          <div className="w-full xl:w-2/12 block xl:flex justify-end items-center relative top-52 md:top-[30rem] xl:top-48 left-56 md:left-[26rem] xl:left-56">
            <div className="bg-[#2c2424] animate-pulse w-16 h-16 xl:w-24 xl:h-24 rounded-full p-2">
              <Image
                alt="Lady using sewing machine"
                className="h-auto"
                src="/assets/case-study/kyc/girl-profile.webp"
                width={80}
                height={80}
              />
              <div className="bg-[#0c69dc] rounded-10 md:p-1">
                <span className="text-xs font-medium text-white font-lato">
                  Tailor
                </span>
              </div>
            </div>
          </div>
          <div className="w-full xl:w-8/12">
            <div className="hidden xl:flex justify-center">
              <Image
                alt="Woman using phone and smiling"
                className="hidden xl:flex justify-center"
                src="/assets/case-study/kyc/kyc-girl.webp"
                width={928}
                height={619}
              />
            </div>
          </div>
          <div className="flex items-center justify-start relative -top-16 -right-32 md:-right-72 md:-top-12 xl:right-56 xl:top-auto w-full xl:w-2/12">
            <div className="bg-[#2c2424] animate-pulse w-16 h-16 xl:w-24 xl:h-24 rounded-full p-2">
              <Image
                alt="Plumber wearing plumbing apron"
                className="h-auto"
                src="/assets/case-study/kyc/men-profile.webp"
                width={80}
                height={80}
              />
              <div className="bg-[#0c69dc] rounded-10 md:p-1">
                <span className="text-xs font-medium text-white font-lato">
                  Plumber
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Hero;
